import React from 'react';
import {
    Collapse, Navbar, NavbarBrand, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import '../css/NavMenu.css';
import { menuShowAction } from '../actions/menuShowAction';
import { useSelector, useDispatch } from "react-redux";
import { useAuth } from './auth/AuthContext';

export function NavMenu() {
    const displayName = NavMenu.name;
    const leftMenuReducer = useSelector(state => state.leftMenuReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getUserInfo, logout } = useAuth();
    const user = getUserInfo();

    function toggleLeftSideMenu(event) {
        event.preventDefault();
        dispatch(menuShowAction(!leftMenuReducer.showMenu));        
    }

    function doLogout() {
        //alert("meow meow");
        logout();
        // Navigate to protected route or dashboard
        navigate('/Home');
    }

    function isAdmin() {
        if (user && user.roles) {
            if (user.roles.some(ur => ur.roleName === 'Admin'))
                return true;
        }
        return false;
    }

    function toggleNavbar() {
        
    }

    return (
        <header>

        <Navbar id="top-nav-menu" className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" expand="md" light>
          <NavbarBrand tag={Link} to="/">ASPnetCoreReact</NavbarBrand>
                <a href="#" onClick={ toggleLeftSideMenu }><i className="fa fa-bars toggle-sidebar-btn" aria-hidden="true"></i></a>
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!false} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/counter">Type Marathi</NavLink>
              </NavItem>
              {user &&
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                        Administration
                    </DropdownToggle>
                    <DropdownMenu end>
                    {/* Dropdown Menu for Administration */}
                    {isAdmin() &&
                        <>
                            <DropdownItem href="/admin/users">
                                Users
                            </DropdownItem>
                            <DropdownItem href="/admin/roles">
                                Roles
                            </DropdownItem>
                            <DropdownItem href="/admin/appusers">
                                App Users
                            </DropdownItem>
                            <DropdownItem divider />
                        </>
                    }
                        <DropdownItem href="/admin/changepassword">
                            Change Password
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
              }
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/world-cities">World Cities</NavLink>
              </NavItem>
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/redux-demo">Redux Demo</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>
              </NavItem>
                {!user &&
                    <NavItem>
                        <NavLink tag={Link} className="text-dark" to="/login">Login</NavLink>
                    </NavItem>
                }
                {user &&
                    <NavItem>
                         <a className="text-dark nav-link" href="#" onClick={doLogout}>Logout</a>
                    </NavItem>
                }
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
}
